import { GET, POST, PUT, DELETE } from '../utils/crud'

const list = async () => {
  const res = await GET('units')
  return res
}

const create = async (body) => {
  const data = { name: body }
  const res = await POST('units', data)
  return res
}

const edit = async (body) => {
  const { id, update } = body
  const data = { name: update }
  const res = await PUT(`units/${id}`, data)
  return res
}

const destroy = async (body) => {
  const res = await DELETE(`units/${body}`)
  return res
}

export default {
  list,
  create,
  edit,
  destroy,
}
